import React, {useEffect} from 'react';
import { Dialog, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import BigAggregateRatingWithStars from '../BigAggregateRatingWithStars';
import { ReviewAppForm } from '../AppDetails/AppActions/ReviewApp/review-app-form';
import { App, DeveloperAppReview } from '../../models/app';
import { canShowStarRating } from '../../component-helpers/app-reviews';
import { useRatingsAndReviews } from '../../contexts/providers/ratings-reviews';
import { SubmitReviewRequestHandler } from '../AppDetails/AppActions/types';
import commonStyles from '../../styles/commonStyles.module.scss';

interface ComponentProps {
  app: App;
  closeModal: () => void;
  open: boolean;
  reviewSubmittedCallBack: SubmitReviewRequestHandler;
  review?: DeveloperAppReview;
}

export const AppReviewModal: React.FC<ComponentProps> = (
  {
    app,
    open,
    closeModal,
    reviewSubmittedCallBack,
    review,
  }): Nullable<JSX.Element> => {
  const { t } = useTranslation();
  const ratingsAndReviewsContext = useRatingsAndReviews();
  const { aggregateRating, id: appId, name: appName, developer } = app;
  const canShowRatings = canShowStarRating(appId, developer.id, aggregateRating.reviewCount, ratingsAndReviewsContext);

  useEffect(() => {
    function keyListener(e: KeyboardEvent) {
      if (e.key === "Escape") {
        closeModal();
      }
    }
    document.addEventListener("keydown", keyListener);
    return () => document.removeEventListener("keydown", keyListener);
  });

  return (
    <Dialog
      onClose={closeModal} open={open} maxWidth={false}
      PaperProps={{ classes: { root: styles.ratingDialog } }}
      aria-modal="true"
      disableAutoFocus={false}
      aria-labelledby={t('app_details.ratings_and_reviews')}
      role="dialog"
      >
      {
        canShowRatings &&
        <>
          <h3>{t('app_details.ratings_and_reviews')}</h3>          
          <BigAggregateRatingWithStars aggregateRating={aggregateRating} />
          <hr className={commonStyles.hr}/>
        </>
      }
      <h2 className={styles.reviewModalHeading}>{t('app_details.rate_this_app')}</h2>
      <caption className={styles.requiredCaption}>{t('app_details.indicates_required')}</caption>
        <IconButton
          onClick={closeModal}
          className = {styles.closeReviewModal}         
          aria-label={t('aria.close')}
		  data-testid='closeIcon'
        >
          <Close />
        </IconButton>
      <ReviewAppForm
        appId={appId} appName={appName} reviewSubmittedCallBack={reviewSubmittedCallBack} review={review}
        showFormAlways={true} cancelCallBack={closeModal} />        
    </Dialog>
  );
};
